import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24">
      <div className="mx-auto max-w-4xl text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 leading-tight">
          {t('cta.title')}
        </h2>
        <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">{t('cta.text')}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/guides/usfans-spreadsheet-guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            {t('cta.primary')}
            <i className="ri-arrow-right-line text-lg" />
          </Link>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-background-100 border border-background-300 text-foreground-900 text-base font-semibold whitespace-nowrap hover:bg-background-200 transition-colors"
          >
            {t('cta.secondary')}
            <i className="ri-arrow-right-up-line text-lg" />
          </a>
        </div>
      </div>
    </section>
  );
}